import { CkEditorNewlineTrimmer } from '../../../util/ckeditor-newline-trimmer';
import { MESSAGE_TYPE, MessageType } from '../../../util/message-types';

const hasNewLines = (message: string) => message.indexOf('\n') >= 0;

// Matches <br>, <br/>, <br />
const hasBrs = (message: string) => message.match(/<br\s?[/]?>/);

const convertEmailMessageToText = (message: string) => {
  const shouldAddNewLinesForText = !hasNewLines(message) && hasBrs(message);

  let formattedMessage = message;
  if (shouldAddNewLinesForText) {
    formattedMessage = message.replace(/<br\s?[/]?>/g, '\n');
  }
  return CkEditorNewlineTrimmer.trimMessage(formattedMessage);
};

const convertTextMessageToEmail = (message: string) => {
  const shouldUntrimForEmail = hasNewLines(message) && !hasBrs(message);
  if (shouldUntrimForEmail) {
    return CkEditorNewlineTrimmer.untrimMessage(message);
  }
  return message;
};

// This is a little strange. When switching back and forth between the messageTypes, you
// can wind up with a string that only has brs or new lines, but not both. The different
// message types require you to have a certain set of brs or new lines, so this code is
// doing the conversion
export const convertMessageType = (message: string, newMessageType: MessageType) => {
  if (newMessageType === MESSAGE_TYPE.TEXT) {
    return convertEmailMessageToText(message);
  }
  return convertTextMessageToEmail(message);
};
